import {
  FulfillmentTypes,
  PrintServiceProductEntityHydrated,
  QuantitySelectorBasic,
  QuantitySelectorWithSuggestions,
} from "@jackfruit/common"
import { z } from "zod"
import { t } from "i18next"

const quantitySelectorConfigSchema = z.union([
  z.object({
    type: z.literal("basic"),
  }),
  z.object({
    type: z.literal("withSuggestions"),
    items: z.array(
      z.object({
        label: z.string(),
        quantity: z.number(),
      })
    ),
  }),
])

let defaultQuantitySelectorConfigBasic: QuantitySelectorBasic = {
  type: "basic",
}

let defaultQuantitySelectorConfigWithSuggestions: QuantitySelectorWithSuggestions =
  {
    type: "withSuggestions",
    items: [
      {
        label: t(
          "components.cart.line-item.quantity-selector.LineItemPreviewQuantitySelectorWithSuggestions.default.family"
        ),
        quantity: 5,
      },
      {
        label: t(
          "components.cart.line-item.quantity-selector.LineItemPreviewQuantitySelectorWithSuggestions.default.wedding"
        ),
        quantity: 50,
      },
      {
        label: t(
          "components.cart.line-item.quantity-selector.LineItemPreviewQuantitySelectorWithSuggestions.default.enterprise"
        ),
        quantity: 500,
      },
    ],
  }

interface GetQuantitySelectorConfigOptions {
  product: PrintServiceProductEntityHydrated
  fulfillment: FulfillmentTypes
}

export const getQuantitySelectorConfig = (
  options: GetQuantitySelectorConfigOptions
) => {
  const { product, fulfillment } = options
  const result = quantitySelectorConfigSchema.safeParse(
    product.metaData?.web?.quantitySelector
  )

  let config: QuantitySelectorBasic | QuantitySelectorWithSuggestions =
    defaultQuantitySelectorConfigBasic

  if (result.success) {
    config = result.data
  } else {
    if (fulfillment === "delivery") {
      // force new quantity selector
      config = defaultQuantitySelectorConfigWithSuggestions
    } else {
      // force old quantity selector
      config = defaultQuantitySelectorConfigBasic
    }
  }

  return config
}
